package br.com.heyagenda.domain.model

data class StudioService(
    val id: String,
    val name: String,
    val category: String,
    val priceFormatted: String,
    val durationMinutes: Int,
    val description: String
)
